import { Address } from '@anyx/shared-utils';

export const AddressTwoDisplay = ({ address }: { address: Address; hasPrevious: boolean }) => {
  return address?.address2 ? <span>{address?.address2}</span> : null;
};
